import { Close } from "@mui/icons-material";
import {
  CardContent,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Typography
} from "@mui/material";
import { BIGrey } from "../../assets/helpers";
import {
  BIGreen,
  BILightGreen,
  BILightGrey,
  BILightYellow,
} from "../../assets/helpers";

export default function ClientChangeStatusModal(props) {
  const { selectedClientData } = props;

  return (
    <div>
      <Modal open={props?.open} onClose={props?.close}>
        <div className="client-modal-responsive" style={{ width: "380px" }}>
          <Grid size={{xs:12, sm:12, md:12, lg:12 }}>
            <Grid
              gap={1}
              container
              sx={{ paddingTop: 2,  paddingBottom: 0,  alignItems: "center",  justifyContent: "space-between" }}
              
              
              
              paddingInline={2}>
              <Grid>
                <Typography variant="body1">{props.TEXT_UPDATE_STATUS}</Typography>
              </Grid>
              <IconButton color="primary" onClick={props?.close} style={{ padding: "0px" }}>
                <Close
                  sx={{
                    color:
                      selectedClientData?.AccentColor !== undefined &&
                      selectedClientData?.AccentColor
                        ? selectedClientData?.AccentColor
                        : BILightGrey
                  }}
                />
              </IconButton>
            </Grid>
            <CardContent>
              <Grid container sx={{ alignItems: "center" }}>
                <Grid>
                  <FormControl>
                    <RadioGroup defaultValue={props.selectedStatus} name="radio-buttons-group">
                      <div
                        style={{
                          border: "1px solid black",
                          marginBottom: "12px",
                          paddingRight: "10rem",
                          borderRadius: "4px",
                          paddingLeft: "1rem"
                        }}>
                        <FormControlLabel
                          onClick={() => {
                            props.saveStatus(1);
                          }}
                          value={props.TEXT_INPROGRESS}
                          control={
                            <Radio
                              checked={props.selectedStatus === "In Progress" ? true : false}
                            />
                          }
                          label={
                            <Chip
                              label={props.TEXT_INPROGRESS}
                              style={{
                                backgroundColor: BILightYellow,
                                color: BIGrey
                              }}
                            />
                          }
                        />
                      </div>
                      <div
                        style={{
                          border: "1px solid black",
                          marginBottom: "12px",
                          paddingRight: "5rem",
                          borderRadius: "4px",
                          paddingLeft: "1rem"
                        }}>
                        <FormControlLabel
                          onClick={() => {
                            props.saveStatus(2);
                          }}
                          value={props.TEXT_ONHOLD}
                          control={
                            <Radio checked={props.selectedStatus === "On Hold" ? true : false} />
                          }
                          label={
                            <Chip
                              label={props.TEXT_ONHOLD}
                              style={{
                                backgroundColor: "pink",
                                color: "brown"
                              }}
                            />
                          }
                        />
                      </div>
                      <div
                        style={{
                          border: "1px solid black",
                          marginBottom: "12px",
                          paddingRight: "5rem",
                          borderRadius: "4px",
                          paddingLeft: "1rem"
                        }}>
                        <FormControlLabel
                          onClick={() => {
                            props.saveStatus(3);
                          }}
                          value={props.TEXT_COMPLETED}
                          control={
                            <Radio checked={props.selectedStatus === "Completed" ? true : false} />
                          }
                          label={
                            <Chip
                              label={props.TEXT_COMPLETED}
                              style={{
                                backgroundColor: BILightGreen,
                                color: BIGreen
                              }}
                            />
                          }
                        />
                      </div>
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Grid>
        </div>
      </Modal>
    </div>
  );
}
